import React, { Component } from "react";
import { Link } from "react-router-dom";
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardHeader } from "mdbreact";
import HomePageNews from "./News/HomePageNews";
import { GetData } from "../api/service";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Container,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import { Button, Divider, Modal } from "antd";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";
import { History } from "./PanduAbout/AboutDescription";
import StickyButton from "./StickyButton";
import Announcements from "./Announcements";
import RecentNews from "./RecentNews";
import HomePageEvents from "./News/HomePageEvents";
import VideoHomePage from "./Video/VideoHomePage";
import HomePageCertificates from "./News/HomePageCertificates";
import HomePageFeatured from "./Essentials/HomePageFeatured";
import StudentsCornerHomePage from "./StudentsCorner/StudentsCornerHomePage";
import KnowYourFaculty from "./KnowYourFaculty/KnowYourFaculty";
import Hightlights from "./Hightlights";
import CollegeMap from "./CollegeMap/CollegeMap";
import HightlightShort from "./HightlightShort";
import HomePageTopDiv from "./HomePageTopDiv";
export default class HomePagePandu extends Component {
  state = {
    events: [],
    isLoaded: false,
    showHoliday: false,
    holidayData: {},
    // isHovered: false
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    GetData(`/getupcomingevents`).then((resp) => {
      console.log("events", resp);
      this.setState((prevState) => {
        return {
          ...prevState,
          events: resp,
          isLoaded: true,
        };
      });
    });

    GetData(`/checkiftodayisholiday`).then((resp) => {
      if (resp != null) {
        this.setState(
          (prevState) => {
            return {
              ...prevState,
              showHoliday: resp.status,
              holidayData: {
                ...resp.data,
              },
            };
          },
          () => {
            this.showHoliday();
          }
        );
      }
    });
  };

  // handleMouseOver (){
  //     this.setIsHovered(true);
  //   };

  // handleMouseLeave = () => {
  //       this.setIsHovered(false);
  //   };

  showHoliday() {
    if (this.state.showHoliday) {
      Modal.info({
        title: this.state.holidayData?.title,
        content: (
          <div>
            <div>
              {Array.isArray(this.state.holidayData.upload_info) &&
                this.state.holidayData.upload_info.map((el) => (
                  <img src={el.url} style={{ width: "100%" }} />
                ))}
            </div>
            From :{" "}
            {moment(this.state.holidayData?.start_date).format("DD/MM/YYYY")} to{" "}
            {moment(this.state.holidayData?.end_date).format("DD/MM/YYYY")}
            <div
              style={{ margin: 0 }}
              dangerouslySetInnerHTML={{
                __html: this.state.holidayData?.description,
              }}
            ></div>
            {/* <br />
          <br />
          <br />
          {this.state.holidayData?.upload_info?.map((el, index) => <>
            <Button type="primary" icon={<DownloadOutlined />} size="small" onClick={() => window.open(`${el.url}}`)}>File {++index}</Button>&nbsp;
          </>
          )} */}
          </div>
        ),
        onOk() {},
        centered: true,
      });
    }
  }
  render() {
    return (
      <div className="fontFix">
      <RecentNews />
      <Container>
        {/*  */}
        <HomePageTopDiv />
        </Container>

        <div>
          <Grid container>
            {/* <Grid item xs={12} sm={12} md={4} lg={4}>
              <div style={{ paddingLeft: 10, paddingRight: 10, marginTop: '-10px' }}>
               
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                  }}
                >
                  Principal's Message
                </Divider>
                <div style={{ width: "100%", position: "relative" }}>
                  <img
                    src="/images/principal-prag.jpeg"
                    className="img-wrap-image"
                  />

                  <div className="p-warp-image">
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ textAlign: "justify", padding: 10 }}
                    >
                      It is a matter of utmost privilege and pleasure to extend
                      a warm and heartiest welcome to all the students desiring
                      to take admission in different programs being offered in
                      this premier higher educational institution of the NE
                      region. Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya had made its humble beginning,
                      under the initiative of a group of visionary leaders of
                      the region. The college has made exemplary strides from
                      its inception till date. Today, it is not only one of the
                      most distinguished undergraduate co-educational
                      institutions in the entire NE region but is also the
                      college of first choice by many, with programs ranging
                      from higher secondary up to post-graduate.......
                    </Typography>

         

                    <div style={{ textAlign: "right" }}>
                      <Link to="/administrations/principal">
                        <Button type="primary">Know More</Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Grid> */}
            <br />

            {/* <Grid item xs={12} sm={12} md={4} lg={4}>
              <div style={{ padding: 20 }}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                    marginTop: "-20px",
                  }}
                >
                  Tenders
                </Divider>
                <HomePageNews
                  type="COLLEGE_TENDER"
                  link="/notifications/tender"
                />
              </div>
            </Grid>*/}
          </Grid>
        </div>

        <div style={{ minHeight: 400 }}>
          <Container>
            <HomePageEvents />
          </Container>
        </div>

        {/* <div style={{ backgroundColor: "#EEEEEE" }}>
          <div style={{ padding: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                  }}
                >
                  STUDENT NOTICES
                </Divider>
                <HomePageNews
                  type="COLLEGE_ACADEMIC_NOTICE"
                  link="/notifications/academic"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                  }}
                >
                  ADMINISTRATIVE NOTICES
                </Divider>
                <HomePageNews
                  type="COLLEGE_ADMIN_NOTICE"
                  link="/notifications/administrative"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                  }}
                >
                  TENDERS
                </Divider>
                <HomePageNews
                  type="COLLEGE_TENDER"
                  link="/notifications/tender"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                  }}
                >
                  DOWNLOADS
                </Divider>
                <HomePageNews type="COLLEGE_DOWNLOADS" link="/notifications/" />
              </Grid>
            </Grid>
          </div>
        </div> */}

        <div></div>

        {/* <div
          style={{
            width: "100%",
            height: "85vh",
            background:
              "url('/images/bg2.png')",
            backgroundRepeat: "no repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {this.state.isLoaded && <div
            style={{
              background: "linear-gradient(180deg,#000A,#0005,#000A)",
              height: "100%",
              width: "100%",
              // display: "flex",
              // justifyContent: "center",
              padding: "2em 0",
              alignItems: 'center',
            }}
          >
            {Array.isArray(this.state.events) && this.state.events.length > 0 && <div style={{

            }}>
              <StickyButton />
              <AliceCarousel
                items={this.state.events.map((el, index) => <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  marginTop: 40
                }} key={index}>
                  <p
                    style={{
                      color: "white",
                      fontSize: "1.7em",
                      fontWeight: "600",
                      textAlign: "center",
                      marginBottom: "1em",
                    }}
                  >
                    Upcoming Events
                  </p>
                  <br />
                  <br />

                  <div className="hr" style={{ width: '50%' }}></div>
                  <div style={{ margin: "4em 0" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "2em 0",
                      }}
                    >
                      <div className="round-date">{el.date_no} {el.month}</div>
                    </div>
                    <div
                      className=""
                      style={{
                        textAlign: "center",
                        color: "white",
                        fontSize: "1.5em",
                        fontWeight: "600",
                      }}
                    >
                      {el.title}
                    </div>

                  </div>
                  <div className="hr" style={{ marginTop: "1em", width: '50%' }}>&nbsp;</div>
                </div>)}
                responsive={{
                  0: { items: 1 },
                  1024: { items: 1 }
                }}
                autoPlayInterval={2000}
                autoPlayDirection="rtl"
                autoPlay={true}
                //fadeOutAnimation={true}
                mouseDragEnabled={true}
                playButtonEnabled={false}
                keysControlDisabled={true}
                dotsDisabled={true}
                buttonsDisabled={true}
              />


            </div>}
          </div>}
        </div> */}

        {/* <MDBRow>
          <RecentNews />
        </MDBRow> */}

        {/* <div style={{width: '100%', height:'20%', backgroundColor: 'white', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <button style={{display: 'inline-block'}}>Announcements</button>
          <hr style={{display: 'inline-block', backgroundColor: 'black'}} />
          </div> */}
        {/* <Container>
          <div
            style={{
              minHeight: 200,
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            
            <Announcements />
          </div>
        </Container>

        <div className="paper-home-page-div">
          <Container>
            <Paper className="paper-home-page-about">
              <div
                style={{
                  flexBasis: "40%",
                  display: "block",
                  minHeight: "100%",
                }}
              >
                <img
                  src="/images/prag-small-overview.jpg"
                  style={{ width: "100%" }}
                />
              </div>
              <div style={{ flexBasis: "60%", padding: 20 }}>
                <Typography
                  variant="h5"
                  style={{ fontWeight: 700 }}
                  gutterBottom
                >
                  About The College
                </Typography>
                <Typography variant="body2" style={{ textAlign: "justify" }}>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pragjyotish
                  College, established on 1st September 1954, seven years after
                  Independence, became a beacon of learning and a symbol of
                  aspirations for the common people of Assam, raring to build a
                  new nation. Pandit Tirthanath Sarma, eminent scholar and
                  litterateur, responded to and actively participated in the
                  nation building by taking charge as the founder Principal of
                  Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya. From its modest inception as an arts
                  college, Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya has now developed into one of the
                  premier institutions of higher education in Guwahati. At
                  present, it is a well-known full-fledged under-graduate
                  college imparting higher education in multiple streams
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Situated on
                  the western bank of the Bharalu, a rivulet, in the western
                  part of Guwahati, Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya . . .{" "}
                  <Link to="/aboutus/about">Read More</Link>
                </Typography>
              </div>
            </Paper>
          </Container>
        </div> */}
        <div className="div-container-icon-shortcut">
  <Container>
    <Divider
      orientation="left"
      style={{
        fontWeight: 700,
        fontSize: 20,
        borderColor: "#ABB2B9",
        marginTop: "-30px",
        color:"white",
      }}
    >
      Similars Organisations
    </Divider>

    <div style={{ display: "flex", gap: 20, }}>
      {[
        {
         
          img: "/images/similar.png",
          link: "https://www.hindustanscoutsandguidesassociation.com/",
        },
        {
          
          img: "/images/similars.png",
          link: "https://www.bsgindia.org/",
        },
        {
         
          img: "/images/similars4.png",
          link: "http://envfor.nic.in/",
        },
        {
          
          img: "/images/similars3.png",
          link: "http://nccindia.nic.in/",
        },
      ].map((item, index) => (
        <div style={{flexBasis: "25%"}} key={index}>
        <a
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "block" }}
      >
          {/* <Link to={item.link} > */}
            <div
            
              // style={{
              //   padding: 14,
              //   textAlign: "center",
              //   background: "#fff",
              //   borderRadius: 12,
              //   boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
              //   cursor: "pointer",
              //   transition: "0.3s",
              // }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "translateY(-6px)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
            >
              <img
                src={item.img}
                // alt={item.title}
                style={{
                  width: "100%",
                  height: 160,
                  objectFit: "contain",
                  borderRadius: 10,
                  marginBottom: 10,
                }}
              />
              
              {/* <div style={{ fontWeight: 700, fontSize: 15, color: "white", textAlign: "center" }}>
                {item.title}
              </div> */}
            </div>
            </a>
          {/* </Link> */}
        </div>
      ))}
    </div>
  </Container>
</div>

        {/* <div className="div-container-icon-shortcut">
          <div>
            <Container>
            <Divider
              orientation="left"
              style={{
                fontWeight: 700,
                fontSize: 20,
                borderColor: "#ABB2B9",
                marginTop: "1px",
              }}
            >
              Gallery
            </Divider>
              <div className="paper-adm-homepage">
                
                <div className="paper-adm-homepage-div">
                
                  <div className="paper-adm-homepage-link">
                    <div className="verticle-card-home">
                      <div className="verticle-card-round">
                        <img
                          src="/images/icons/teacher.png"
                          style={{ width: 50 }}
                        />
                      </div>
                      <div style={{ fontSize: 34 }}>37</div>
                      <div>Faculty</div>
                    </div>
                  </div>
                </div>
                <div className="paper-adm-homepage-div">
                  <div className="paper-adm-homepage-link">
                    <div className="verticle-card-home">
                      <div className="verticle-card-round">
                        <img
                          src="/images/icons/staff.png"
                          style={{ width: 50 }}
                        />
                      </div>
                      <div style={{ fontSize: 34 }}>14</div>
                      <div>Non-teaching staff</div>
                    </div>
                  </div>
                </div>
                <div className="paper-adm-homepage-div">
                  <div className="paper-adm-homepage-link">
                    <div className="verticle-card-home">
                      <div className="verticle-card-round">
                        <img
                          src="/images/icons/stream.png"
                          style={{ width: 50 }}
                        />
                      </div>
                      <div style={{ fontSize: 34 }}>02</div>
                      <div>Stream</div>
                    </div>
                  </div>
                </div>
                <div className="paper-adm-homepage-div">
                  <div className="paper-adm-homepage-link">
                    <div className="verticle-card-home">
                      <div className="verticle-card-round">
                        <img
                          src="/images/icons/department.png"
                          style={{ width: 50 }}
                        />
                      </div>
                      <div style={{ fontSize: 34 }}>13</div>
                      <div>Department</div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </div> */}

        <div>
          <Container>
            <Divider
              orientation="left"
              style={{
                fontWeight: 700,
                fontSize: 20,
                borderColor: "#ABB2B9",
                marginTop: "40px",
              }}
            >
              Gallery
            </Divider>
            <HightlightShort type="COLLEGE" />
            <br />
          </Container>
        </div>

        {/* <div style={{ minHeight: 400 }}>
          <br />
          <KnowYourFaculty />

          <br />
          <br />
        </div> */}

        {/* <div style={{ minHeight: 400 }}>
         
          <CollegeMap />

          <br />
          <br />
        </div> */}

        {/* <div style={{ backgroundColor: "#f9f9f9", padding: 10 }}>
           Event Slider
          
            <Hightlights />
        
        </div> */}

        {/* <div style={{ minHeight: 400 }}>
          <br />
          <VideoHomePage />

          <br />
          <br />
        </div> */}

        {/* <div style={{ backgroundColor: "#192F59" }}>
          <Container>
            <div className="paper-homepage-awards-div">
              <div style={{ flexBasis: "50%" }}>
                <Typography
                  variant="h6"
                  style={{ color: "white", fontSize: 20, fontWeight: 700 }}
                >
                  Awards and Accreditations
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  flexBasis: "50%",
                  alignItems: "center",
                }}
              >
                <a href="https://www.ugc.ac.in/" target="_blank">
                  <div
                    style={{
                      minHeight: 60,
                      width: 80,
                      backgroundColor: "white",
                      borderRadius: 10,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontWeight: 700,
                      flexDirection: "column",
                      marginRight: 20,
                      padding: 10,
                    }}
                  >
                    <img src="/images/icons/ugc.jpeg" style={{ width: 50 }} />
                    UGC
                  </div>
                </a>
                <a href="https://www.aus.ac.in/" target="_blank">
                  <div
                    style={{
                      minHeight: 60,
                      width: 80,
                      backgroundColor: "white",
                      borderRadius: 10,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontWeight: 700,
                      flexDirection: "column",
                      marginRight: 20,
                      padding: 10,
                    }}
                  >
                    <img src="/images/AU_logo.png" style={{ width: 40 }} />
                    AU
                  </div>
                </a>
                <a href="https://www.ahsec.assam.gov.in/" target="_blank">
                  <div
                    style={{
                      minHeight: 60,
                      width: 80,
                      backgroundColor: "white",
                      borderRadius: 10,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontWeight: 700,
                      flexDirection: "column",
                      marginRight: 20,
                      padding: 10,
                    }}
                  >
                    <img
                      src="/images/ahsec_pandit.jpeg"
                      style={{ width: 40 }}
                    />
                    AHSEC
                  </div>
                </a>
              </div>
            </div>
          </Container>
        </div> */}

        {/* <div className="news py-4">
          <MDBContainer>
            <p
              style={{
                color: "#b94735",
                fontSize: "2.7em",
                fontWeight: "600",
                textAlign: "center",
                margin: "2em 0 0 0",
              }}
            >
              Take A Tour Of the College
            </p>
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8 my-4 vdamaz">
                <iframe
                  width="100%"
                  style={{ aspectRatio: "1.6410" }}
                  src="https://www.youtube.com/embed/BtDCX335d9E"
                  title="YouTube video player"
                  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                </iframe>
              </div>
              <div className="col-md-2"></div>
            </div>
          </MDBContainer>

        </div> */}
        {/* <HomePageFeatured /> */}
      </div>
    );
  }
}
